import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';

const EmployeeIcon = ({ size = 'sm', color = 'currentColor' }: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M8 6.756c0 .542-.19 1.039-.508 1.427.855.576 1.463 1.589 1.463 2.918a.75.75 0 0 1-1.5 0c0-1.305-.894-1.954-1.711-1.954s-1.712.65-1.712 1.954a.75.75 0 0 1-1.5 0c0-1.33.608-2.342 1.464-2.917A2.256 2.256 0 1 1 8 6.757m-2.256.757a.756.756 0 1 0 0-1.513.756.756 0 0 0 0 1.513"
      clipRule="evenodd"
    />
    <path d="M10.01 5.15a.75.75 0 0 0 0 1.5h2.5a.75.75 0 1 0 0-1.5zM9.26 8.4a.75.75 0 0 1 .75-.75h1.642a.75.75 0 0 1 0 1.5H10.01a.75.75 0 0 1-.75-.75" />
    <path
      fillRule="evenodd"
      d="M0 5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v6.718a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3zm3-1.5h10A1.5 1.5 0 0 1 14.5 5v6.718a1.5 1.5 0 0 1-1.5 1.5H3a1.5 1.5 0 0 1-1.5-1.5V5A1.5 1.5 0 0 1 3 3.5"
      clipRule="evenodd"
    />
  </svg>
);
EmployeeIcon.id = 'EmployeeIcon';
EmployeeIcon.displayName = 'EmployeeIcon';
export default EmployeeIcon;
